"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChannelsData = void 0;
var react_1 = __importStar(require("react"));
var initialState = {
    channels: [],
    loadingEarlier: false,
    loadingLater: false,
    hasMoreEarlier: false,
    liveUpdate: true,
    errorMessage: undefined,
    maxRetryAttemptsReached: false,
    blackList: [],
};
var reducer = function (state, action) {
    if (action.type === 'update' || action.type === 'delete') {
        var channelsStorage = action.chatService.getChannelStorage();
        return __assign(__assign({}, state), channelsStorage.state());
    }
    return state;
};
var useChannelsData = function (chatService) {
    var _a = react_1.default.useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    var loadEarlier = react_1.useCallback(function () {
        if (chatService) {
            chatService.loadEarlierChannels();
        }
    }, [chatService]);
    react_1.default.useEffect(function () {
        if (chatService) {
            var channelsStorage = chatService.getChannelStorage();
            var removeUpdateListener_1 = channelsStorage.onUpdate(function () {
                dispatch({ type: 'update', chatService: chatService });
            });
            var removeDeleteListener_1 = channelsStorage.onDelete(function () {
                dispatch({ type: 'delete', chatService: chatService });
            });
            return function () {
                removeUpdateListener_1();
                removeDeleteListener_1();
            };
        }
    }, [chatService]);
    react_1.default.useEffect(function () {
        if (chatService) {
            var unSubscribeChannelsUpdate_1 = chatService.subscribeChannelsUpdate();
            return function () {
                unSubscribeChannelsUpdate_1();
            };
        }
    }, [chatService]);
    return [state, loadEarlier];
};
exports.useChannelsData = useChannelsData;
//# sourceMappingURL=useChannelsData.js.map